import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import  { Button, Typography,  ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary,
    Grid, CircularProgress, Divider, Paper
} from "@material-ui/core";
import  { ExpandMore, Search, SaveAltTwoTone } from "@material-ui/icons"; 
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import moment from "moment";
import "react-day-picker/lib/style.css";
import "./style.css";
import {FilterPanels} from "./filterPanel";
import ReactTable from "react-table";
import { columns } from "./tblColumns";
import ReportService from "../../../services/ReportService";
import ReactExport from "react-data-export";
import { Tag } from "antd";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const reportService =  new ReportService();

const styles = theme => ({
    root: {
        width: "100%",
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: "33.33%",
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
        marginRight: theme.spacing.unit
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    button: {
        marginTop: theme.spacing.unit,
        marginBottom : theme.spacing.unit,
    },
    progress: {
        margin: theme.spacing.unit * 2,
    },
    devider:{
        marginTop: theme.spacing.unit,
        marginBottom : theme.spacing.unit,
    },
    panels: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
});

class report extends Component {

    constructor(props) {
        super(props);
        this.state = {
            from: undefined,
            to: undefined,
            expanded: null,
            card: false,
            bank: false,
            mwallet: false,
            rwallet: false,
            dpoint: false,
            mcash: false,
            ezcash: false,
            incomplete:false,
            pending:false,
            success:false,
            fail:false,
            data: [],
            isLoading: false,
            pages: "",
            isShow: false
        };
        this.handleFromChange = this.handleFromChange.bind(this);
        this.handleToChange = this.handleToChange.bind(this);
        this._search = this._search.bind(this);
    }

    showFromMonth() {
        const { from, to } = this.state;
        if (!from) {
            return;
        }
        if (moment(to).diff(moment(from), "months") < 2) {
            this.to.getDayPicker().showMonth(from);
        }
    }
    handleFromChange(from) {
    // Change the from date and focus the "to" input field
        this.setState({ from });
    }
    handleToChange(to) {
        this.setState({ to }, this.showFromMonth);
    }

  handleChange = panel => (event, expanded) => {
      this.setState({
          expanded: expanded ? panel : false,
      });
  };

  handleCheckBoxChange = name => event => {
      this.setState({ [name]: event.target.checked });
  };

  _search(){
      this.setState({
          data: [],
          isLoading:true,
          isShow: true,
          expanded: false
      });

      let sourceArr = [];
      let channelArr = [];
      let statusArr = [];

      if(this.state.card){
          sourceArr.push("CARD");
      }
      if(this.state.bank){
          sourceArr.push("ACCOUNT");
      }
      if(this.state.mwallet){
          sourceArr.push("MERCHANT_WALLET");
      }
      if(this.state.rwallet){
          sourceArr.push("REDMO_POINTS");
      }
      if(this.state.dpoint){
          sourceArr.push("POINTS");
      }

      if(this.state.mcash){
          channelArr.push("mCash");
      }
      if(this.state.ezcash){
          channelArr.push("ezCash");
      }

      if(this.state.incomplete){
          statusArr.push("incomplete");
      }
      if(this.state.pending){
          statusArr.push("pending");
      }
      if(this.state.success){
          statusArr.push("success");
      }
      if(this.state.fail){
          statusArr.push("failed");
      }

      let params = {
          fromDate: moment(this.state.from).format("YYYY-MM-DD"),
          toDate: moment(this.state.to).format("YYYY-MM-DD"),
          source: sourceArr,
          channel: channelArr,
          status:statusArr
      };

      reportService.adminGetAllTransaction(params, (err,res )=>{
          if(err){
              console.log(err);
              this.setState({
                  isLoading:false
              });
          }else{
              this.setState({
                  data: res.results,
                  pages: res.pages,
                  isLoading:false
              });
          }
      });
  }

  render() {
      const { classes } = this.props;
      const { expanded, from, to, data, isLoading, isShow} = this.state;
      const modifiers = { start: from, end: to };

      return (
          <div>
              <ExpansionPanel expanded={expanded === "tranDatePanel"} onChange={this.handleChange("tranDatePanel")}>
                  <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                      <Typography className={classes.heading}>Date Option</Typography>
                      <div className={classes.secondaryHeading}>
                          <Tag color='blue'>{moment(from).format("YYYY-MM-DD")}</Tag><Tag color='blue'>{moment(to).format("YYYY-MM-DD")}</Tag>
                      </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <div className="InputFromTo">
                          <DayPickerInput
                              value={from}
                              placeholder={`${formatDate(new Date())}`}
                              format="LL"
                              formatDate={formatDate}
                              parseDate={parseDate}
                              dayPickerProps={{
                                  selectedDays: [from, { from, to }],
                                  disabledDays: { after: to },
                                  toMonth: to,
                                  modifiers,
                                  numberOfMonths: 2,
                                  onDayClick: () => this.to.getInput().focus(),
                              }}
                              onDayChange={this.handleFromChange}
                          />
                          {" "}—TO—{" "}
                          <span className="InputFromTo-to">
                              <DayPickerInput
                                  ref={el => (this.to = el)}
                                  value={to}
                                  placeholder={`${formatDate(new Date())}`}
                                  format="LL"
                                  formatDate={formatDate}
                                  parseDate={parseDate}
                                  dayPickerProps={{
                                      selectedDays: [from, { from, to }],
                                      disabledDays: { before: from },
                                      modifiers,
                                      month: from,
                                      fromMonth: from,
                                      numberOfMonths: 2,
                                  }}
                                  onDayChange={this.handleToChange}
                              />
                          </span>
                      </div>
                  </ExpansionPanelDetails>
              </ExpansionPanel>

              <FilterPanels states={this.state} allProps={this.props} onChange={this.handleChange} 
                  CheckBoxChange={this.handleCheckBoxChange}
              />
        
              <Grid
                  container
                  direction="row"
                  justify="flex-end"
                  alignItems="flex-start"
              >
                  <Button fullWidth variant="contained" color="primary" className={classes.button} 
                      disabled = {isLoading}
                      onClick={() => {this._search();}}>
            Search
                      <Search className={classes.rightIcon}>send</Search>
                  </Button>        
              </Grid>

              {isLoading ?
                  <Grid
                      container
                      direction="row"
                      justify="center"
                      alignItems="flex-start"
                  >
                      <CircularProgress className={classes.progress} color="secondary" />       
                  </Grid>
                  : 
                  null
              }    

              {isLoading || !isShow ?
                  null
                  :
                  <div> 
                      <Divider variant="middle" className={classes.devider} />

                      <ExcelFile element=
                          {
                              <Button
                                  variant="contained"
                                  color="primary"
                                  className={classes.button}
                                  size="small"
                              >
                                  <SaveAltTwoTone className={classes.rightIcon}>send</SaveAltTwoTone>
                        Export
                              </Button>
                          }
                      filename = {"report_directpay_transaction"}
                      >
                          <ExcelSheet data={data} name="dp_transaction">
                              <ExcelColumn label="Reference" value="id"/>
                              <ExcelColumn label="Date/Time" value="dateTime"/>
                              <ExcelColumn label="Payer Account Number" value="payerAccountNumber"/>
                              <ExcelColumn label="Payer User Name" value="payerUserName"/>
                              <ExcelColumn label="Payer Phone Number" value="payerPhoneNumber"/>
                              <ExcelColumn label="Payer Bank" value="payerBank"/>
                              <ExcelColumn label="Payee User Name" value="payeeUserName"/>
                              <ExcelColumn label="Type" value="type"/>
                              <ExcelColumn label="Merchant Response" value="castomParam"/>
                              <ExcelColumn label="Status" value="status"/>
                              <ExcelColumn label="Currency" value="currency"/>
                              <ExcelColumn label="Banker Response Desc" value="bankerResponseDesc"/>
                              <ExcelColumn label="MCash" value={(col) => col.billPaymentChannel === "mCash" ? col.responseFromMerchant : null} />
                              <ExcelColumn label="EzCash" value={(col) => col.billPaymentChannel === "ezCash" ? col.responseFromMerchant : null}/>
                              <ExcelColumn label="PayCorp" value={(col) => col.payUsing === "CARD" ? col.bankerTransId : null} />
                              <ExcelColumn label="Bank" value={(col) => col.payUsing === "ACCOUNT" ? col.bankerTransId : null} />
                              <ExcelColumn label="Amount(Rs.)" value="originalAmount"/>
                          </ExcelSheet>
                      </ExcelFile>

                      <Paper elevation={1}>
                          <ReactTable
                              data={data}
                              columns={columns}
                              defaultPageSize={10}
                              pageSizeOptions={[5, 10, 20, 25, 50, 100,data.length]}
                              showPageJump={false}
                              loadingText= {<CircularProgress size={30} thickness={5} />}
                              noDataText = {"No transaction available"}
                              className="-striped -highlight"
                              filterable={true}
                              style={{
                                  height: "450px" 
                              }}
                          />
                      </Paper>
                  </div>
              }
          </div>
      );
  }
}


export default withStyles(styles)(report);
